import { ServiceTokens } from "$src/domain/ServiceTokens";
import { Customer } from "$src/domain/customers/Customer";
import type { IProjectRepository } from "$src/domain/projects/IProjectRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetCustomerByProjectId {
    
    constructor(@inject(ServiceTokens.ProjectService) private projectRepository: IProjectRepository) {}

    async execute(groupStoreId: number, projectId: number): Promise<Customer> {
        var project = await this.projectRepository.getCustomerByProjectId(groupStoreId, projectId);
        return project;
    }
}

export const GetCustomerByProjectIdToken = Symbol('GetCustomerByProjectIdToken');    
